import { render, staticRenderFns } from "./SyncStatusBadge.vue?vue&type=template&id=34aee1ba&scoped=true&"
import script from "./SyncStatusBadge.vue?vue&type=script&lang=ts&"
export * from "./SyncStatusBadge.vue?vue&type=script&lang=ts&"
import style0 from "./SyncStatusBadge.vue?vue&type=style&index=0&id=34aee1ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34aee1ba",
  null
  
)

export default component.exports